import { AxiosPromise, CancelToken } from 'axios';
import { GoogleCodeResponse } from '../sic-lib/types/GoogleAuth';
import { apiInstance as instance } from './';

export function requestAuthorizeGoogle(
    data: GoogleCodeResponse,
    cancelToken: CancelToken,
): AxiosPromise<string> {
    return instance.post('/googleauth/oauth', data, {
        headers: {
            'Content-Type': 'application/json',
        },
        cancelToken: cancelToken,
    });
}

export function requestDisconnectGoogle(cancelToken: CancelToken): AxiosPromise<void> {
    return instance.post('/googleauth/disconnect', null, {
        headers: {
            'Content-Type': 'application/json',
        },
        cancelToken: cancelToken,
    });
}

export function requestSubscribeToWebhook(cancelToken: CancelToken): AxiosPromise<string> {
    return instance.post('/googleauth/SubscribeToWebhook', null, {
        headers: {
            'Content-Type': 'application/json',
        },
        cancelToken: cancelToken,
    });
}

export function requestUnsubscribeFromWebhook(cancelToken: CancelToken): AxiosPromise<void> {
    return instance.post('/googleauth/UnsubscribeFromWebhook', null, {
        headers: {
            'Content-Type': 'application/json',
        },
        cancelToken: cancelToken,
    });
}

export function requestDeleteGoogleData(cancelToken: CancelToken): AxiosPromise<void> {
    return instance.post('/googleauth/DeleteGoogleData', null, {
        headers: {
            'Content-Type': 'application/json',
        },
        cancelToken: cancelToken,
    });
}
